import React from "react";
import { useNavigate } from "react-router-dom";

const pages = [
  { label: "Dashboard", path: "/dashboard" },
  {
    label: "Observability (Sentry / Prometheus)",
    path: "/debug/observability",
  },
  { label: "Shopify Export", path: "/debug/shopify-export" },
  { label: "Amazon Reports (debug)", path: "/debug/amazon/reports" },
];

export default function TempPagesHub() {
  const navigate = useNavigate();

  return (
    <div style={{ padding: 32, fontFamily: "sans-serif" }}>
      <h2 style={{ marginTop: 0 }}>Debug / Temp Pages</h2>
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          gap: 10,
          maxWidth: 320,
        }}
      >
        {pages.map(({ label, path }) => (
          <button
            key={path}
            onClick={() => navigate(path)}
            style={{
              padding: "10px 16px",
              textAlign: "left",
              background: "#1976d2",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              fontSize: 15,
            }}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}
